var _I18nComponent_subscription;
import { __classPrivateFieldGet } from "tslib";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, Optional } from "@angular/core";
import { Logger } from "@smallstack/core-common";
import { combineLatest, Subscription } from "rxjs";
import { LocaleService } from "../../services/locale.service";
import { TranslationStore } from "../../stores/translation.store";
import * as i0 from "@angular/core";
import * as i1 from "../../stores/translation.store";
import * as i2 from "../../services/locale.service";
export class I18nComponent {
    constructor(translationStore, cdr, localeService) {
        this.cdr = cdr;
        this.localeService = localeService;
        this.showMissingKey = true;
        this.translationCount = 0;
        this.initialized = false;
        // wtf
        // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
        _I18nComponent_subscription.set(this, new Subscription());
        if (translationStore)
            this.translationStore = translationStore;
    }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set showMissingKeyInput(showMissingKey) {
        this.showMissingKey = showMissingKey === "true" || showMissingKey === true;
    }
    ngOnChanges(changes) {
        // only react to changes if component is already initialized
        if (this.initialized) {
            void this.translate();
        }
    }
    ngOnInit() {
        // translate on locale/store change
        const observables = [];
        if (this.localeService.currentLocale$)
            observables.push(this.localeService.currentLocale$);
        if (this.translationStore?.value$)
            observables.push(this.translationStore?.value$);
        __classPrivateFieldGet(this, _I18nComponent_subscription, "f").add(combineLatest(observables).subscribe((val) => {
            void this.translate();
            this.initialized = true;
        }));
    }
    ngOnDestroy() {
        __classPrivateFieldGet(this, _I18nComponent_subscription, "f").unsubscribe();
    }
    onHover(e) {
        if (e.shiftKey) {
            Logger.info("I18nComponent", "================ I18N DEBUG ================");
            Logger.info("I18nComponent", " |-- Data:             " + this.data);
            Logger.info("I18nComponent", " |-- Replacers:        " + JSON.stringify(this.replacers));
            Logger.info("I18nComponent", " |-- Locale:           " + this.getLocaleForTranslation());
            Logger.info("I18nComponent", " |-- Value:            " + JSON.stringify(this.value));
            Logger.info("I18nComponent", " |-- Show Missing Key: " + this.showMissingKey, typeof this.showMissingKey);
            Logger.info("I18nComponent", " |-- #translated:      " + this.translationCount);
            Logger.info("I18nComponent", " |-- TranslationStore: ", this.translationStore);
        }
    }
    translate() {
        this.translationCount++;
        if (this.data === undefined)
            return;
        if (!this.translationStore) {
            Logger.debug("I18nComponent", "No translation store set!");
            if (typeof this.data === "string") {
                this.value = this.data;
                this.cdr.markForCheck();
            }
            else if (this.data instanceof Array) {
                this.value = this.data[0]?.value;
            }
        }
        else {
            this.value = this.translationStore.translate(this.data, {
                locale: this.getLocaleForTranslation(),
                replacers: this.replacers,
                showMissingKey: this.showMissingKey
            });
            this.cdr.markForCheck();
        }
    }
    getLocaleForTranslation() {
        if (this.locale)
            return this.locale;
        return this.localeService.currentLocale$.value;
    }
}
_I18nComponent_subscription = new WeakMap();
I18nComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: I18nComponent, deps: [{ token: i1.TranslationStore, optional: true }, { token: i0.ChangeDetectorRef }, { token: i2.LocaleService }], target: i0.ɵɵFactoryTarget.Component });
I18nComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.5", type: I18nComponent, selector: "smallstack-i18n", inputs: { data: "data", showMissingKeyInput: ["showMissingKey", "showMissingKeyInput"], replacers: "replacers", locale: "locale", translationStore: "translationStore" }, host: { listeners: { "mouseover": "onHover($event)" } }, usesOnChanges: true, ngImport: i0, template: "{{ value }}\n", styles: [":host{min-height:16px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: I18nComponent, decorators: [{
            type: Component,
            args: [{ selector: "smallstack-i18n", changeDetection: ChangeDetectionStrategy.OnPush, template: "{{ value }}\n", styles: [":host{min-height:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationStore, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: i2.LocaleService }]; }, propDecorators: { data: [{
                type: Input
            }], showMissingKeyInput: [{
                type: Input,
                args: ["showMissingKey"]
            }], replacers: [{
                type: Input
            }], locale: [{
                type: Input
            }], translationStore: [{
                type: Input
            }], onHover: [{
                type: HostListener,
                args: ["mouseover", ["$event"]]
            }] } });
